import { forwardRef, Ref, type SVGProps } from 'react';

const SvgMenuIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 6h18M3 12h18M3 18h18"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMenuIcon);
export default ForwardRef;
